import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceTypeAppResource from "./WorkspaceTypeAppResource";
import LuWorkspaceMembershipTypeAppResource from "./LuWorkspaceMembershipTypeAppResource";
import ServiceProviderTypeAppResource from "./ServiceProviderTypeAppResource";

class ProjectTypeRoleAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'project-type-role';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'projects/types/roles';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'projectTypeUuid',
            'projectMemberRoleUuid',
            'projectType',
            'projectMemberRole',
            'serviceProviderTypeUuid',
            'serviceProviderType',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            projectType: WorkspaceTypeAppResource,
            projectMemberRole: LuWorkspaceMembershipTypeAppResource,
            serviceProviderType: ServiceProviderTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            projectType: 'project_type_uuid',
            projectMemberRole: 'project_member_role_uuid',
            serviceProviderType: 'service_provider_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            projectTypeUuid: {
                type: 'string',
                presence: true
            },
            projectMemberRoleUuid: {
                type: 'string',
                presence: true
            },
            serviceProviderTypeUuid: {
                type: 'string',
            },
        };
    }
}

export default ProjectTypeRoleAppResource;
